import { Injectable } from '@angular/core';
@Injectable()
export class ConstService {
  labelOptions="Accompagnement";
}


